var voted_users_rtlignore_default = {
  "container": "l-HgU",
  "webview": "kZXaf",
  "avatar_list": "E-t78",
  "avatar": "MvWUF",
  "user_avatar": "mE6Hp",
  "modal": "bPaOG",
  "voted_users_modal": "-G6e2",
  "overlay": "q2hqN",
  "user_card": "h6x43",
  "user_name": "Ydf4p",
  "voted_users_modal_header": "_0waT3",
  "cta": "eegIJ",
  "close_icon": "aX3k2",
  "title": "MgjG6",
  "member_list_container": "Y8osT",
  "member_list": "_5Bi3H",
  "loader": "caHOs",
  "anonymous_counter": "_21m7l",
  "spinner": "ivbVV",
  "spin": "ViXzX"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
